<div class="container">
    <div class="row" id="footerBar">
            <div >
              <ul class="list-inline topNavItems bottomNavbar">
                <li>Last Update: 26/07/2019</li>
                <li id="copyright">© 2001-2019 Chevron Corporation</li>
                <li id="confidential">Company Confidential</li>
                <li>Owner Oranization: Upstream</li>
              </ul>
              
            </div>
    </div>
</div>

